import { render, staticRenderFns } from "./VipPrompt.vue?vue&type=template&id=71e272d9&scoped=true"
import script from "./VipPrompt.vue?vue&type=script&lang=js"
export * from "./VipPrompt.vue?vue&type=script&lang=js"
import style0 from "./VipPrompt.vue?vue&type=style&index=0&id=71e272d9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e272d9",
  null
  
)

export default component.exports